export default "__VITE_ASSET__0a71df84__"